<template>

<list-view-page
  title='Appointment Types'
  group-by-field='service'
  initial-view='card'
  :list-item='li'
  :card-item='card'
  :attrs='attrs'
  :touch='touch'
  :with-add='true'
  :request.sync='request'
  @new='quickAdd=true'
  @delete='showConfirmationDialog'
  @selected='performEdit'
  @edit='performEdit' >
  <!-- @new='launchQuickCreateAppointmentType(spaceId)' -->

  <template v-if='quickAdd' >
    <!-- :space-id='selectedSpaceId' -->
    <quick-appointment-type-form
      :practitioner-id='meId'
      @input="productAdded"
      @close="quickAdd=false" />
  </template>

  <template slot='title-right' >
    <v-tabs v-model='activeTab' class='mb-0' >
      <v-tab
        v-for='space in spaces' :key='space.id'
        @click='setSpace(space)' >{{ space.title }}</v-tab>
      <v-spacer />
      <v-switch dense v-model='showArchived' label='Show Archived' class='mr-2' />
    </v-tabs>
    <!-- <practitioner-picker
      :space-id='spaceId'
      v-model='practitioner' /> -->
  </template>

  <template slot='group-title' slot-scope="props" >
    <v-card flat class='mb-3' >
      <v-subheader class='grey lighten-4'
        v-if='getSpaceById(props.item.service)' >
        {{getSpaceById(props.item.service).title}}
      </v-subheader>
      <v-divider/>
      <v-btn
        @click='quickAdd=true'
        small fab absolute bottom right ><v-icon>mdi-plus</v-icon></v-btn>
    </v-card>
  </template>

  <template slot='dialogs' >
    <v-dialog v-model='confirmdelete' width='400' >
      <v-card>
        <v-card-title class='overline' >
          Confirm archive
        </v-card-title>
        <v-card-text v-if='selectedAt' >
          Are you sure you want to archive the appointment type: {{selectedAt.title}}?
        </v-card-text>
        <v-card-text v-else >
          <p>Something has gone wrong. We're not sure which appointment type you want to
          archive. Please close this dialog and click the archive button again.
          </p><p>
          If that still doesn't work, try refreshing the page.
          </p><p>
          If that _still_ doesn't work, please contact support.
          </p>
        </v-card-text>
        <v-card-actions >
          <v-spacer />
          <v-btn color='error'
            :loading='deleteRequest.loading'
            @click='performDelete(selectedAt)' >Archive</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
</list-view-page>
</template>
<script>
import ListViewPage from '@/components/layouts/ListViewPage.vue'
import AppointmentTypeListItem from '@/components/listitems/AppointmentTypeListItem.vue'
import AppointmentTypeCardListItem from '@/components/listitems/AppointmentTypeCardListItem.vue'
import QuickAppointmentTypeForm from '@/components/actions/forms/QuickAppointmentTypeForm.vue'
import {mapGetters} from 'vuex'

export default {
  name: 'ProfileAppointmentTypesPage',
  components: {
    ListViewPage,
    QuickAppointmentTypeForm
  },
  data () {
    return {
      activeTab: null,
      confirmdelete: false,
      showArchived: false,
      quickAdd: false,
      selectedAt: null,
      li: AppointmentTypeListItem,
      card: AppointmentTypeCardListItem,
      request: {
        resource: 'ag.spaces.products.v3',
        params: {
          ordering: 'service_id,practitioner_id,order', // ,order
          archived: false
        },
        result: { results: [] }
      },
      deleteRequest: {
        resource: 'ag.spaces.products'
      },
      touch: 0,
      space: {},
      attrs: {}
    }
  },
  computed: {
    ...mapGetters('identity', ['meId', 'getPractitionerById', 'spacesList', 'getSpaceById']),
    selectedSpaceId () {
      if (this.space) {
        return this.space.id
      }
      return null
    },
    me () {
      return this.getPractitionerById(this.meId)
    },
    deleteRequestStatus () {
      return this.deleteRequest.status
    },
    touchId () {
      let atState = this.getObjectPath(this.$store.state.events, 'appointment-type-form.touch')
      let newAtState = this.getObjectPath(this.$store.state.events, 'quick-appointment-type-form.touch')
      return atState + '/' + newAtState
    }
  },
  watch: {
    selectedSpaceId () {
      if (this.selectedSpaceId) {
        this.request.params.service = this.selectedSpaceId
        this.touch++
      }
    },
    touchId () {
      this.touch++
    },
    showArchived () {
      if (this.showArchived === true) {
        this.request.params.archived = null
      } else {
        this.request.params.archived = false
      }
      this.touch++
    },
    deleteRequestStatus () {
      if (this.deleteRequestStatus === 204) {
        this.touch++
        this.selectedAt = null
        this.confirmdelete = false
      }
    },
    spacesList: {
      immediate: true,
      handler () {
        if (this.spacesList && this.spacesList.length > 0) {
          this.setSpace(this.spacesList[0])
        }
      }
    }
  },
  methods: {
    setSpace (space) {
      this.space = space
    },
    performEdit (appointmentType) {
      let title = `${this.spaceName} - ${appointmentType.title}`
      this.launchAppointmentTypeForm(appointmentType.service, appointmentType.id, title)
    },
    showConfirmationDialog (at) {
      this.selectedAt = at
      this.confirmdelete = true
    },
    performDelete (at) {
      this.deleteRequest.resourceId = at.id
      this.$request('delete', this.deleteRequest)
    },
    productAdded (at) {
      this.request.result.results.push(at)
      this.touch++
      this.init()
    }
  }
}
</script>
